import BoxInfo from '@/components/boxInfo/boxInfo';
import Filters, { FieldsToFilter } from '@/components/dataGrid/components/filters/filters';
import { useParamsState } from '@/components/dataGrid/hooks/useParamsState/useParamsState';
import { MOVE_ROW_BENEFICIARY_STATUS } from '@/modules/move/entities/enums/move';
import { BaseSearchParams } from '@/shared/entities';
import React from 'react';

export const moveListFilterFieldOptions = {
  search: {
    label: 'Buscar',
    key: 'q',
  },
  type: {
    label: 'Tipo',
    key: 'action',
    type: 'select',
    data: [
      {
        text: 'Inclusão',
        value: 'creation',
      },
      {
        text: 'Exclusão',
        value: 'removal',
      },
      {
        text: 'Alteração',
        value: 'update',
      },
    ],
  },
  beneficiaryStatus: {
    label: 'Status da vida',
    key: 'rows.beneficiaryStatus',
    type: 'select',
    multiple: true,
    data: [
      {
        text: 'Erros',
        value: MOVE_ROW_BENEFICIARY_STATUS.VALIDATED_WITH_ERROR,
      },
      {
        text: 'Criticas',
        value: MOVE_ROW_BENEFICIARY_STATUS.PROCESSED_WITH_ERROR,
      },
      {
        text: 'Em andamento',
        value: MOVE_ROW_BENEFICIARY_STATUS.NOT_INITIALIZED,
      },
      {
        text: 'Concluídos',
        value: MOVE_ROW_BENEFICIARY_STATUS.PROCESSED,
      },
    ],
  },
  createdAtMin: {
    label: 'Data',
    key: 'createdAtMin',
    type: 'date',
  },
};

export type MoveListFilterFieldKey = keyof typeof moveListFilterFieldOptions;

interface MoveListFilterProps<Filter extends BaseSearchParams> {
  fields: {
    key: MoveListFilterFieldKey;
    width: number;
  }[];
  elevation?: number;
  paramsState: Filter;
  changeParam: (value: Filter) => void;
}

export const MoveListFilter = function <Filter extends BaseSearchParams>({
  fields,
  elevation,
  paramsState,
  changeParam,
}: MoveListFilterProps<Filter>) {
  const [paramsFiltersBox, setParamsFiltersBox] = useParamsState<{ showMoreFilters: boolean }>({
    initialState: { showMoreFilters: false },
  });

  const filterFields = fields.map(
    (field) =>
      ({
        ...moveListFilterFieldOptions[field.key],
        width: field.width,
      }) as FieldsToFilter<Filter>,
  );

  return (
    <BoxInfo elevation={elevation} margin={0}>
      <Filters
        values={paramsState}
        fields={filterFields}
        handleChange={(values) =>
          changeParam({
            ...values,
            showMoreFilters: paramsFiltersBox.showMoreFilters,
          })
        }
        setShowMoreFilters={(show) =>
          setParamsFiltersBox({ ...paramsState, showMoreFilters: show })
        }
        showMoreFilters={paramsFiltersBox.showMoreFilters}
      />
    </BoxInfo>
  );
};
